/**
 * VoiceIcon/index.js
 * desc: voice icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const VoiceIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="voice icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.voice.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 14 19" xmlns="http://www.w3.org/2000/svg"><path d="M9.99 9c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3V3c0-1.66 1.34-3 3-3s3 1.34 3 3l-.01 6zM7 14.1c2.76 0 5.3-2.1 5.3-5.1H14c0 3.42-2.72 6.24-6 6.72V19H6v-3.28c-3.28-.49-6-3.3-6-6.72h1.7c0 3 2.54 5.1 5.3 5.1z" /></svg>
    </IconButton>
);


export default VoiceIcon;
